var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar__fill",style:({ width: _vm.progressWidth })}),_c('div',{staticClass:"progress-bar__stages"},_vm._l((_vm.stages),function(stage,index){return _c('span',{key:index,class:{ active: _vm.currentStage >= index }},[_vm._v(" "+_vm._s(stage)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }